<template>
    <!-- <div>
        <CCard>
            <CCardHeader class="d-flex justify-content-between align-items-center">
                <strong>Активные заказы</strong>
                <small class="text-muted">Обновление каждые 15 секунд</small>
            </CCardHeader>
            <CCardBody>
                <div v-if="loadingOrders" class="table__preloader">
                    <CSpinner color="primary" />
                </div>
                <template v-else>
                    <OrdersTable
                        :list.sync="orders"
                        :total="ordersCount"
                        :use-filter="false"
                        :use-sorter="false"
                        :use-search="false"
                    />
                </template>
            </CCardBody>
        </CCard>
        <CCard>
            <CCardHeader class="d-flex justify-content-between align-items-center">
                <strong>Последние чаты</strong>
                <div class="d-flex align-items-center">
                    <CLink to="/chats" class="mr-3">Все чаты</CLink>
                    <small class="text-muted">Обновление каждые 15 секунд</small>
                </div>
            </CCardHeader>
            <CCardBody>
                <div v-if="loadingChats" class="table__preloader">
                    <CSpinner color="primary" />
                </div>
                <template v-else>
                    <div v-if="!chats.length" class="text-muted">
                        Активных чатов пока нет
                    </div>
                    <div v-else class="chat-summary-cards">
                        <ChatSummaryCard
                            v-for="chat in chats"
                            :key="chat.chat_id"
                            :chat="chat"
                            @select="openCustomer"
                        />
                    </div>
                </template>
            </CCardBody>
        </CCard>
    </div> -->
</template>

<script>
    import Vue from 'vue';
    // import OrdersTable from '@/components/orders/OrdersTable';
    // import ChatSummaryCard from '@/components/chats/ChatSummaryCard';

    export default {
        name: 'Dashboard',
        // components: {
        //     OrdersTable,
        //     ChatSummaryCard
        // },
        // data () {
        //     return {
        //         loadingChats: true,
        //         loadingOrders: true,
        //         chats: [],
        //         orders: [],
        //         ordersCount: 0,
        //         refreshTimerId: null
        //     }
        // },
        // async mounted() {
        //     await this.loadActiveChats();
        //     await this.loadActiveOrders();
        //     this.refreshTimerId = setInterval(() => {
        //         this.loadActiveChats(false);
        //         this.loadActiveOrders(false);
        //     }, 15000);
        // },
        // beforeDestroy() {
        //     if (this.refreshTimerId) {
        //         clearInterval(this.refreshTimerId);
        //         this.refreshTimerId = null;
        //     }
        // },
        // methods: {
        //     async loadActiveChats(useLoader = true) {
        //         if (useLoader) {
        //             this.loadingChats = true;
        //         }
        //         try {
        //             const { data } = await Vue.axios.get('/chats/active', {
        //                 params: {
        //                     page: 1,
        //                     limit: 5
        //                 }
        //             });
        //             this.chats = data.items || [];
        //         } catch (e) {
        //             this.$root.$emit('showError', 'Не удалось загрузить активные чаты');
        //         } finally {
        //             this.loadingChats = false;
        //         }
        //     },
        //     async loadActiveOrders(useLoader = true) {
        //         if (useLoader) {
        //             this.loadingOrders = true;
        //         }
        //         try {
        //             const { data } = await Vue.axios.get('/orders', {
        //                 params: {
        //                     main: 1,
        //                     in_work: true
        //                 }
        //             });
        //             this.orders = Array.isArray(data) ? data : [];
        //             this.ordersCount = this.orders.length;
        //         } catch (e) {
        //             this.$root.$emit('showError', 'Не удалось загрузить активные заказы');
        //         } finally {
        //             this.loadingOrders = false;
        //         }
        //     },
        //     openCustomer(chat) {
        //         this.$router.push({
        //             name: 'Chat',
        //             params: {
        //                 chatId: chat.chat_id
        //             }
        //         });
        //     }
        // }
    }
</script>
